export default __webpack_public_path__ + "static/media/ic_play.1eabbd03.png";